import { FormikProps, useFormik } from 'formik';
import { getAddExercisePropertyFormValidation } from './FormikData';
import { useTranslation } from 'react-i18next';
import { IExerciseProperty } from '../../../../types/interfaces/exercise-property';
import { FormikValues } from 'formik/dist/types';
import {
  useGetExerciseProperties,
  usePostPutExerciseProperty,
} from '../../../../services/redux/api/exerciseConfigAPI';
import { useState } from 'react';
import { useLayout } from '../../../../context/LayoutContext';
import { useGetFilePaths } from '../../../../services/redux/api/appConfigApi';
import {
  deleteFilesFromFirebase,
  uploadFileAndCreateAppFile,
} from '../../../../utils/firebase-storage-utils';

export function useAddExercisePropertyComponent(
  onClose: () => void,
  exerciseProperty?: IExerciseProperty,
) {
  const { t } = useTranslation();
  const [postPutExerciseProperty] = usePostPutExerciseProperty();
  const [avatar, setAvatar] = useState(null);
  const { data: exerciseProperties } = useGetExerciseProperties();
  const { data: filePaths } = useGetFilePaths();
  const [isLoading, setIsLoading] = useState(false);
  const formik: FormikProps<any> = useFormik({
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: getAddExercisePropertyFormValidation(t),
    initialValues: {
      nameKey: exerciseProperty?.nameKey || '',
      type: exerciseProperty?.type || '',
      parent: exerciseProperty?.parent || '',
      active: exerciseProperty?.active || false,
      priority: exerciseProperty?.priority || null,
      isDefault: exerciseProperty?.isDefault ?? false,
    },
    onSubmit: onSubmit,
  });

  async function onSubmit(values: FormikValues) {
    if (!filePaths) {
      return;
    }

    let avatarFile;
    const uploadedStoragePaths: string[] = [];

    try {
      setIsLoading(true);

      if (avatar) {
        avatarFile = await uploadFileAndCreateAppFile(
          avatar,
          filePaths.exerciseProperty,
        );

        uploadedStoragePaths.push(avatarFile.storageLink);
        if (avatarFile.previewStorageLink) {
          uploadedStoragePaths.push(avatarFile.previewStorageLink);
        }
      }

      await postPutExerciseProperty({
        id: exerciseProperty?.id,
        body: {
          nameKey: values.nameKey,
          type: values.type,
          parentId: values.parent?.id || null,
          active: values.active,
          priority: values.priority,
          isDefault: values.isDefault,
          ...(avatarFile && { avatar: avatarFile }),
        } as any,
      }).unwrap();

      onClose();
    } catch (error) {
      console.error(
        'Error uploading avatar or saving exercise property:',
        error,
      );
      if (uploadedStoragePaths.length > 0) {
        await deleteFilesFromFirebase(uploadedStoragePaths);
      }
    } finally {
      setIsLoading(false);
    }
  }

  return { formik, isLoading, avatar, setAvatar, exerciseProperties };
}
